import { LoaderPage } from 'ht-styleguide';

/**
 * We don't want the user stagnating on non-pre built /pages rendering for first time
 * users to that page. Lets present a simple loading screen.
 *
 * @param {string} message
 * @constructor
 */
const LoaderPages = ({ message = 'Loading Requested Page. Thank You!' }) => (
  <div className="text-align-center positionRelative paddingTop-large">
    <LoaderPage />
    <h5 className="paddingTop-large">{message}</h5>
  </div>
);

export default LoaderPages;
